import { render, staticRenderFns } from "./WinView.vue?vue&type=template&id=a973b07a&scoped=true"
import script from "./WinView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WinView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WinView.vue?vue&type=style&index=0&id=a973b07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a973b07a",
  null
  
)

export default component.exports